import React, { useState } from 'react';
import { Mail, Check } from 'lucide-react';
import { subscribeNewsletter } from '../api/client';

export default function NewsletterCapture({ source = 'homepage', compact = false }) {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | busy | done | error
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes('@')) {
      setMsg('That doesn\'t look like a valid email.');
      return;
    }
    setState('busy');
    setMsg(null);
    try {
      await subscribeNewsletter(email, source);
      setState('done');
    } catch (err) {
      setState('error');
      setMsg(err?.response?.data?.detail || 'Could not subscribe — try again in a moment.');
    }
  };

  if (state === 'done') {
    return (
      <div className={`newsletter-capture done ${compact ? 'compact' : ''}`} data-testid="newsletter-done">
        <Check size={16} /> You are on the list. Keep an eye on your inbox.
      </div>
    );
  }

  return (
    <form className={`newsletter-capture ${compact ? 'compact' : ''}`} onSubmit={submit} data-testid="newsletter-capture">
      <div className="newsletter-header">
        <Mail size={14} />
        <span>{compact ? 'Weekly AI drop' : 'Get the weekly AI drop'}</span>
      </div>
      {!compact && (
        <p className="muted">
          The 5 most interesting new AI tools and creators each week — in your inbox, on Fridays. No spam.
        </p>
      )}
      <div className="newsletter-form">
        <input
          type="text"
          inputMode="email"
          placeholder="you@work.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={state === 'busy'}
          data-testid="newsletter-email"
        />
        <button className="pill-btn primary" type="submit" disabled={state === 'busy'} data-testid="newsletter-submit">
          {state === 'busy' ? '…' : 'Subscribe'}
        </button>
      </div>
      {msg && <div className="error-msg" style={{ marginTop: 8 }}>{msg}</div>}
    </form>
  );
}
